import createStore from "astrid-helpers/src/createStore";

export const [getAutoScroll, setAutoScroll, useAutoScroll, onAutoScroll] = createStore(true);
